import '../../services/recorder/recorder-core';
//import '../../services/recorder/wav';  // 加载wav编码器
import '../../services/recorder/mp3';  // 加载mp3编码器
import '../../services/recorder/mp3-engine';  // 加载mp3编码器
export default {
    data() {
        return {
            accessKey: '',
            status: '',
            recordId: '',
            serverId: '',
            recorder: null,
            type: 'mp3',
            bit: 16, // 比特率
            sample: 48000, // 采样率
            recblob: {},
            file: ''
        }
    },
    mounted() {
        this.accessKey = sessionStorage.getItem('accessKey');
        this.load();
        this.isIosWechat();
    },
    methods: {
        load() {
            console.log('===load===');
            this.recorder = Recorder({
                type: this.type
                ,bitRate: this.bit
                ,sampleRate: this.sample
                ,onProcess:(buffers,level,time,sampleRate)=>{
                    console.log('time,',time);
                    console.log('level,',level);
                }
            });
            
            this.recorder.open(()=>{
                console.log("已打开:"+this.type+" "+this.sample+"hz "+this.bit+"kbps");
            },(e,isUserNotAllow)=>{
                console.log((isUserNotAllow?"UserNotAllow，":"")+"打开失败："+e);
            });
            
            window.waitDialogClick=()=>{
                console.log("打开失败：权限请求被忽略，用户主动点击的弹窗");
            };
        },
        start(){
            console.log('===start===');
            this.status = 'start...'
            if(this.isWeChatOpen() && this.isIosApp()) {
                console.log('===wechat start===');
                wx.ready(()=>{
                    wx.startRecord({
                        success: (e)=>{
                            console.log('startRecord===',e);
                        }
                    })
                });
                return;
            }
            if(this.recorder){
                this.recorder.start();
                let set = this.recorder.set;
                console.log("录制中："+set.type+" "+set.sampleRate+"hz "+set.bitRate+"kbps");
            }else{
                console.log("未打开录音");
            };
        },
        stop() {
            console.log('===stop===');
            this.status = 'stop...'
            if(this.isWeChatOpen() && this.isIosApp()) {
                console.log('===wechat stop===');
                wx.stopRecord({
                    success: (res)=>{
                        this.recordId = res.localId;
                    }
                });
                return;
            }
            if(this.recorder){
                var t1=Date.now();
                this.recorder.stop((blob,time)=>{
                    this.recblob['randomkey1']={blob:blob,time:time};
                    this.file = blob;
                },(s)=>{
                    console.log("失败："+s);
                });
            }else{
                console.log("未打开录音");
            };
        },
        play1() {
            console.log('===play===');
            this.status = 'play...'
            if(this.isWeChatOpen() && this.isIosApp()) {
                console.log('===wechat play===');
                wx.playVoice({
                    localId: this.recordId
                });
                return;
            }
            let audio = this.$refs['recPlay1'];
            audio.controls=true;
            if(!(audio.ended || audio.paused)){
                audio.pause();
            };
            var o=this.recblob['randomkey1'];
            if(o){
                o.play=(o.play||0)+1;
                audio.onerror=()=>{
                    console.log('播放失败['+audio.error.code+']'+audio.error.message);
                };
                let end=(blob)=>{
                    audio.src=(window.URL||webkitURL).createObjectURL(blob);
                    audio.play();
                };
                let wav=Recorder[this.type+"2wav"];
                if(wav){
                    console.log("正在转码成wav...");
                    wav(o.blob,(blob)=>{
                        end(blob);
                        console.log("已转码成wav播放");
                    },(msg)=>{
                        console.log("转码成wav失败："+msg);
                    });
                }else{
                    end(o.blob);
                };
                console.log('blob===>',o.blob);
            };
        },
        play() {
            let audio = this.$refs['recPlay1'];
            audio.controls=true;
            if(!(audio.ended || audio.paused)){
                audio.pause();
            };
            // audio.src=(window.URL||webkitURL).createObjectURL(`https://webot-dev.wld.net/file/1/${this.serverId}`);
            audio.play();
        },
        upload() {
            if(this.isWeChatOpen() && this.isIosApp()) {
                wx.uploadVoice({
                    localId: this.recordId,
                    isShowProgressTips: 1, // 默认为1，显示进度提示
                        success: (res)=> {
                        this.file = res.serverId; // 返回音频的服务器端ID
                        this.uploadRecord();
                    }
                });
            }else {
                this.uploadRecord();
            }
        },
        async uploadRecord() {
            let formData = new FormData();
            formData.append('accessKey', this.accessKey);
            formData.append('type', 3);
            formData.append('channel', 1);
            if(this.isWeChatOpen() && this.isIosApp()) {
                formData.append('url', `${window.api}/adaptor/wechat/media/${this.file}`);
            }else {
                formData.append('file', this.file);
            }
            let res = await this.$http.postFile(`/upload`,formData);
            if(!res) return;
            this.serverId = res.data.fileId;
        },
        isWeChatOpen() {
            return navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1;
        },
        isIosApp() {
            return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
        },
        async isIosWechat() {
            if(this.isWeChatOpen() && this.isIosApp()) {
                let res = await this.$http.wechatRequest(`/ticket/jsapi?accessKey=${sessionStorage.getItem('accessKey')}`);
                if(!res) return;
                let data = res;
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: data.appId, // 必填，公众号的唯一标识
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                    signature: data.signature,// 必填，签名，见附录1
                    jsApiList: ['startRecord','stopRecord','onVoiceRecordEnd','playVoice', 'uploadVoice'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });
            }
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/recorder-demo/_recorder.js